<!-- 操作列，各种按钮的交互 -->
<template>
  <div class="m-l-0">
    <el-badge
      v-if="row.showReportSent"
      :value="row?.reportCount"
      :max="99"
      class="item m-t-10 m-r-2"
    >
      <i
        class="icon-jubao1"
        :class="{ red: row?.reportCount > 0 }"
        :style="{
          cursor: row?.reportCount > 0 ? 'not-allowed' : 'pointer',
        }"
        @click="report"
      ></i>
      <div>
        <span :class="{ red: row?.reportCount > 0 }">
          {{ row.reportCount > 0 ? '已举报' : '举报标记' }}
        </span>
      </div>
    </el-badge>
    <br />
    <el-button
      type="danger"
      plain
      v-if="row.showReturnQcTask"
      style="width: 100px; text-align: center; margin-left: -2px"
      @click.stop="openReturnTaskPoolDialog"
    >
      打回任务池
    </el-button>
    <el-button
      type="success"
      plain
      :disabled="row?.qcStatus === 3"
      v-if="row.showReadNoMistake"
      style="width: 100px; text-align: center; margin-left: -2px"
      @click.stop="readNoMistake"
    >
      已阅无误
    </el-button>
    <el-button
      type="info"
      plain
      v-if="isShowViewContext"
      style="width: 100px; text-align: center; margin-left: -2px"
      @click.stop="viewContext"
    >
      查看上下文
    </el-button>
    <el-button
      type="primary"
      plain
      v-if="row.showCancelMerge"
      style="width: 100px; text-align: center; margin-left: -2px"
      @click.stop="cancelMerge"
    >
      取消合并
    </el-button>
  </div>
</template>

<script>
import { reportSent } from '@/api/dot/qc';

export default {
  name: 'ActionBtns',
  props: [
    'row',
    'peStatus',
    'qcTaskId',
    'userInfo',
    'orderTag',
    'hasContextView',
  ],
  computed: {
    // 是否展示“查看上下文”
    isShowViewContext() {
      return this.hasContextView && this.row?.repeatId == null;
    },
  },
  methods: {
    // 小灯泡举报
    report() {
      const { reportCount, name, id, lastAuditerId, qcTaskId } = this.row || {};
      if (reportCount > 0) {
        return;
      }
      this.$confirm('是否确认举报"' + name + '"审核的此句子？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        reportSent({
          sentId: id,
          auditorId: lastAuditerId,
          qcTaskId: qcTaskId,
          reporterId: this.userInfo?.staffId,
        }).then(() => {
          // TODO 为啥直接修改引用
          this.row.reportCount += 1;
          // this.loadPage();
          // this.$emit('load-page');
        });
      });
    },
    // 打回任务池
    openReturnTaskPoolDialog() {
      this.$emit('open-return-task-pool-dialog', this.row);
    },
    // 已阅无误
    readNoMistake() {
      this.$emit('read-no-mistake', this.row);
    },
    // 查看上下文
    viewContext() {
      this.$emit('view-context', this.row);
    },
    // 取消合并
    cancelMerge() {
      this.$emit('open-cancel-merge-dialog', this.row);
    },
  },
};
</script>
